import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCross, faListAlt, faTshirt, faMapMarkerAlt, faMusic, 
  faCheck, faTasks, faUsers, faFlag, faGraduationCap, faMedal, faCheckCircle, 
  faBullseye, faHeart, faHandshake, faBalanceScale,
  faCircle, faShieldAlt, faGem, faChessKnight
} from '@fortawesome/free-solid-svg-icons';
import Pathfinder_logo from './images/Pathfinder_logo.jpeg';
import Pathfinder_Insignia_Positions_on_Shirt_no_tie from './images/Pathfinder-Insignia-Positions-on-Shirt-no-tie.jpg';
import Pathfinder_Insignia_Positions_on_Shirt_and_the_Sash_no_tie from './images/Pathfinder-Insignia-Positions-on-Shirt-and-the-Sash-no-tie.jpg';
import Pathfinder_Uniform_Right_Sleeve from './images/Pathfinder-Uniform-Right-Sleeve.jpg';
import Pathfinder_Uniform_Left_Sleeve from './images/Pathfinder-Uniform-Left-Sleeve.jpg';
import pathfinder_song from './images/pathfinder-song.jpg';
import Area_Pathfinder_Coordinator_Epaulette from './images/Area-Pathfinder-Coordinator-Epaulette.webp';
import Conference_Pathfinder_Director_Epaulette from './images/Conference-Pathfinder-Director-Epaulette.webp';
import Union_Pathfinder_Director_Epaulette from './images/Union-Pathfinder-Director-Epaulette.webp';
import Division_Pathfinder_Director_Epaulette from './images/Division-Pathfinder-Director-Epaulette.webp';
import General_Conference_Pathfinder_Director_Epaulette from './images/General-Conference-Pathfinder-Director-Epaulette.webp';
import planningCommitImage from './images/pathfinders.jpg';

const Pathfinders = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const sections = [
    { id: 'Philosophy-Objectives', title: 'Philosophy & Objectives' },
    { id: 'Chart-Organization', title: 'Organization' },
    { id: 'Membership-Requirements', title: 'Membership' },
    { id: 'Aim-Motto-Pledge-Law', title: 'Law & Pledge' },
    { id: 'Meaning-Of-The-Pathfinder-Club-Emblem', title: 'Emblem' },
    { id: 'Uniform', title: 'Uniform' },
    { id: 'Insignia', title: 'Insignia' },
    { id: 'Song', title: 'Song' },
    { title: 'Adventurers', href: 'Adventurers' },
    { title: 'Ambassadors', href: 'Ambassadors' },
    { title: 'Young Adults', href: 'YoungAdults' },
    { title: 'PCM', href: 'PCM' }
  ];

  return (
    <>
      <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-green-50">
        <Header />
        
        <main className="pt-24">
          <div className="max-w-7xl mx-auto px-4">
            {/* Navigation */}
            <nav className="mb-12">
              <div className="flex flex-wrap gap-2 justify-center">
                {sections.map((section, idx) => (
                  section.href ? (
                    <a
                      key={idx}
                      href={section.href}
                      className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-5 py-2.5 rounded-full font-semibold hover:from-indigo-700 hover:to-purple-700 transform hover:scale-105 transition-all duration-300 shadow-lg text-sm"
                    >
                      {section.title}
                    </a>
                  ) : (
                    <a
                      key={idx}
                      href={`#${section.id}`}
                      className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-5 py-2.5 rounded-full font-semibold hover:from-green-700 hover:to-emerald-700 transform hover:scale-105 transition-all duration-300 shadow-lg text-sm"
                    >
                      {section.title}
                    </a>
                  )
                ))}
              </div>
            </nav>

            {/* Philosophy & Objectives */}
            <section id="Philosophy-Objectives" className="scroll-mt-24 mb-20">
              <div className="grid md:grid-cols-2 gap-8">
                <div className="bg-gradient-to-br from-white to-blue-50 rounded-3xl shadow-2xl p-8">
                  <div className="flex items-center mb-6">
                    <div className="bg-gradient-to-r from-blue-500 to-cyan-500 p-3 rounded-xl mr-4">
                      <FontAwesomeIcon icon={faCross} className="text-white text-2xl" />
                    </div>
                    <h2 className="text-3xl font-bold text-gray-800">PHILOSOPHY</h2>
                  </div>
                  <div className="space-y-4 text-gray-600 leading-relaxed">
                    <p>The Seventh-day Adventist Church is committed to understanding young people and training its youth for leadership and service to humanity.</p>
                    <p>The Pathfinder Club is a church-centered spiritual-recreational-activity program designed for young people 10 to 15 years of age.</p>
                    <p>The whole philosophy of Pathfindering is built on the premise that "children learn best by example, rather than precept."</p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-white to-emerald-50 rounded-3xl shadow-2xl p-8">
                  <div className="flex items-center mb-6">
                    <div className="bg-gradient-to-r from-emerald-500 to-green-500 p-3 rounded-xl mr-4">
                      <FontAwesomeIcon icon={faCross} className="text-white text-2xl" />
                    </div>
                    <h2 className="text-3xl font-bold text-gray-800">Objectives</h2>
                  </div>
                  <div className="space-y-4">
                    {[
                      'Help the young people to understand that God and His church love them...',
                      'Encourage Pathfinders to discover their own God-given potential...',
                      'Inspire young people to give personal expression of their love for God...',
                      'Make the number one priority the personal salvation of every Pathfinder...',
                      'Build appreciation and love for God\'s creation...',
                      'Teach Pathfinders specific skills and hobbies...',
                      'Encourage the Pathfinder to keep physically fit...',
                      'Give opportunity for the development of leadership...',
                      'Seek to foster harmonious development...'
                    ].map((item, idx) => (
                      <div key={idx} className="flex items-start">
                        <FontAwesomeIcon icon={faCheck} className="text-emerald-500 mt-1 mr-3 flex-shrink-0" />
                        <span className="text-gray-600">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* Organization Chart */}
            <section id="Chart-Organization" className="scroll-mt-24 mb-20">
              <div className="bg-gradient-to-br from-white to-amber-50 rounded-3xl shadow-2xl p-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Pathfinder Chart Organization</h2>
                
                <div className="grid md:grid-cols-3 gap-6">
                  <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6">
                    <div className="flex items-center mb-4">
                      <div className="bg-gradient-to-r from-blue-500 to-cyan-500 p-2 rounded-lg mr-3">
                        <FontAwesomeIcon icon={faTasks} className="text-white" />
                      </div>
                      <h3 className="text-xl font-bold text-gray-800">Steps to Organize</h3>
                    </div>
                    <ul className="space-y-3">
                      {[
                        'Counsel with Conference Youth Ministries',
                        'Meet with Pastor and Conference personnel',
                        'Present plans to Church Board',
                        'Elect Pathfinder director and deputies',
                        'Inform congregation',
                        'Elect Executive Committee',
                        'First meeting of Executive Committee'
                      ].map((step, idx) => (
                        <li key={idx} className="flex items-start">
                          <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3"></div>
                          <span className="text-gray-600">{step}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-2xl p-6">
                    <div className="flex items-center mb-4">
                      <div className="bg-gradient-to-r from-emerald-500 to-green-500 p-2 rounded-lg mr-3">
                        <FontAwesomeIcon icon={faUsers} className="text-white" />
                      </div>
                      <h3 className="text-xl font-bold text-gray-800">Membership Structure</h3>
                    </div>
                    <ul className="space-y-3">
                      {[
                        'Pathfinder Club Members',
                        'Counselors & Instructors',
                        'Deputy Directors',
                        'Club Director',
                        'Local Church Board',
                        'Area Coordinators',
                        'Conference Director',
                        'Union Director',
                        'Division Director',
                        'General Conference Director'
                      ].map((member, idx) => (
                        <li key={idx} className="flex items-start">
                          <div className="w-2 h-2 bg-emerald-500 rounded-full mt-2 mr-3"></div>
                          <span className="text-gray-600">{member}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6">
                    <div className="flex items-center mb-4">
                      <div className="bg-gradient-to-r from-purple-500 to-pink-500 p-2 rounded-lg mr-3">
                        <FontAwesomeIcon icon={faGraduationCap} className="text-white" />
                      </div>
                      <h3 className="text-xl font-bold text-gray-800">Pathfinder Classes</h3>
                    </div>
                    <div className="space-y-3">
                      {[
                        { name: 'Friend', age: '10 years', color: 'bg-blue-500' },
                        { name: 'Companion', age: '11 years', color: 'bg-red-500' },
                        { name: 'Explorer', age: '12 years', color: 'bg-green-500' },
                        { name: 'Ranger', age: '13 years', color: 'bg-gray-400' },
                        { name: 'Voyager', age: '14 years', color: 'bg-purple-600' },
                        { name: 'Guide', age: '15 years', color: 'bg-yellow-500' }
                      ].map((cls, idx) => (
                        <div key={idx} className="flex items-center justify-between p-3 bg-white rounded-lg">
                          <div className="flex items-center">
                            <div className={`w-3 h-3 rounded-full ${cls.color} mr-3`}></div>
                            <span className="font-semibold text-gray-700">{cls.name}</span>
                          </div>
                          <span className="text-gray-500">{cls.age}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Aim, Motto, Pledge & Law */}
            <section id="Aim-Motto-Pledge-Law" className="scroll-mt-24 mb-20">
              <div className="text-center mb-12">
                <h2 className="text-4xl font-bold text-gray-800 mb-4">Pathfinder Principles</h2>
                <div className="w-32 h-1 bg-gradient-to-r from-green-500 to-emerald-500 mx-auto"></div>
              </div>

              <div className="grid md:grid-cols-4 gap-6">
                {[
                  {
                    icon: faBullseye,
                    title: 'AIM',
                    content: 'The Advent Message to all the world in my generation.',
                    color: 'from-orange-500 to-red-500'
                  },
                  {
                    icon: faHeart,
                    title: 'Motto',
                    content: 'The love of Christ compels us.',
                    color: 'from-pink-500 to-rose-500'
                  },
                  {
                    icon: faHandshake,
                    title: 'Pledge',
                    content: 'By the grace of God, I will be pure and kind and true. I will keep the Pathfinder Law.',
                    color: 'from-blue-500 to-cyan-500'
                  },
                  {
                    icon: faBalanceScale,
                    title: 'Law',
                    content: 'Keep the morning watch. Do my honest part. Care for my body. Keep a level eye. Be courteous and obedient.',
                    color: 'from-emerald-500 to-green-500'
                  }
                ].map((item, idx) => (
                  <div key={idx} className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-xl p-6 transform hover:-translate-y-2 transition-all duration-300">
                    <div className={`bg-gradient-to-r ${item.color} p-3 rounded-xl w-12 h-12 flex items-center justify-center mb-4`}>
                      <FontAwesomeIcon icon={item.icon} className="text-white text-xl" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-3">{item.title}</h3>
                    <p className="text-gray-600">{item.content}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Emblem Meaning */}
            <section id="Meaning-Of-The-Pathfinder-Club-Emblem" className="scroll-mt-24 mb-20">
              <div className="bg-gradient-to-br from-white to-blue-50 rounded-3xl shadow-2xl p-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Meaning of the Pathfinder Club Emblem</h2>
                
                <div className="grid md:grid-cols-3 gap-6">
                  {[
                    {
                      symbol: 'Red',
                      meaning: 'Sacrifice',
                      description: 'Reminds us of Christ. "For God so loved the world..."'
                    },
                    {
                      symbol: 'Three sides',
                      meaning: 'Completeness',
                      description: 'Trinity - Father, Son, Holy Spirit. Tripod of education: Mental, Physical, Spiritual.'
                    },
                    {
                      symbol: 'Gold',
                      meaning: 'Excellence',
                      description: '"I counsel thee to buy of me gold tried in the fire..."'
                    },
                    {
                      symbol: 'Shield',
                      meaning: 'Protection',
                      description: 'God is our shield. "Above all, taking the shield of faith..."'
                    },
                    {
                      symbol: 'White',
                      meaning: 'Purity',
                      description: '"He that overcometh... shall be clothed in white raiment."'
                    },
                    {
                      symbol: 'Blue',
                      meaning: 'Loyalty',
                      description: 'Loyalty to God, parents, and church.'
                    },
                    {
                      symbol: 'Sword',
                      meaning: 'Bible',
                      description: 'The Word of God as our weapon. "The sword of the Spirit is the Word of God."'
                    },
                    {
                      symbol: 'Triangle',
                      meaning: 'Service',
                      description: 'Sacrificial service and humility. Following Jesus teaching on servant leadership.'
                    }
                  ].map((item, idx) => (
                    <div key={idx} className="bg-white rounded-xl p-5 shadow-lg transform hover:scale-105 transition-all duration-300">
                      <div className="flex items-center mb-3">
                        <div className="w-3 h-3 rounded-full bg-gradient-to-r from-green-500 to-emerald-500 mr-2"></div>
                        <h3 className="font-bold text-gray-800">{item.symbol}</h3>
                      </div>
                      <div className="text-sm font-semibold text-green-600 mb-2">{item.meaning}</div>
                      <p className="text-gray-600 text-sm">{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* Uniform Section */}
            <section id="Uniform" className="scroll-mt-24 mb-20">
              <div className="bg-gradient-to-br from-white to-amber-50 rounded-3xl shadow-2xl p-8">
                <div className="flex items-center justify-center mb-8">
                  <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-4 rounded-xl mr-4">
                    <FontAwesomeIcon icon={faTshirt} className="text-white text-3xl" />
                  </div>
                  <h2 className="text-4xl font-bold text-gray-800">Uniform</h2>
                </div>

                <div className="grid md:grid-cols-2 gap-8">
                  <div className="bg-white rounded-2xl shadow-lg p-6">
                    <div className="flex items-center mb-6">
                      <div className="w-3 h-8 bg-gradient-to-b from-blue-500 to-cyan-500 rounded-full mr-3"></div>
                      <h3 className="text-2xl font-bold text-gray-800">Class A Uniform</h3>
                    </div>
                    <div className="space-y-3">
                      <div className="flex justify-between p-3 bg-blue-50 rounded-lg">
                        <span className="font-semibold">Shirt/Blouse</span>
                        <span className="text-blue-600">White</span>
                      </div>
                      <div className="flex justify-between p-3 bg-green-50 rounded-lg">
                        <span className="font-semibold">Pants/Skirt</span>
                        <span className="text-green-600">Green</span>
                      </div>
                      <div className="flex justify-between p-3 bg-yellow-50 rounded-lg">
                        <span className="font-semibold">Scarf</span>
                        <span className="text-yellow-600">Yellow</span>
                      </div>
                      <div className="flex justify-between p-3 bg-gray-50 rounded-lg">
                        <span className="font-semibold">Shoes</span>
                        <span className="text-gray-600">Black</span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-2xl shadow-lg p-6">
                    <div className="flex items-center mb-6">
                      <div className="w-3 h-8 bg-gradient-to-b from-emerald-500 to-green-500 rounded-full mr-3"></div>
                      <h3 className="text-2xl font-bold text-gray-800">Class B Uniform</h3>
                    </div>
                    <div className="space-y-3">
                      <div className="flex justify-between p-3 bg-amber-50 rounded-lg">
                        <span className="font-semibold">Shirt/Blouse</span>
                        <span className="text-amber-600">Khaki</span>
                      </div>
                      <div className="flex justify-between p-3 bg-emerald-50 rounded-lg">
                        <span className="font-semibold">Pants/Skirt</span>
                        <span className="text-emerald-600">Green or Khaki</span>
                      </div>
                      <div className="flex justify-between p-3 bg-yellow-50 rounded-lg">
                        <span className="font-semibold">Scarf</span>
                        <span className="text-yellow-600">Yellow</span>
                      </div>
                      <div className="flex justify-between p-3 bg-gray-50 rounded-lg">
                        <span className="font-semibold">Shoes</span>
                        <span className="text-gray-600">Black</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Uniform Images */}
                <div className="mt-12 grid md:grid-cols-2 gap-8">
                  <div className="bg-white rounded-2xl shadow-lg p-6">
                    <h4 className="text-xl font-bold text-gray-800 mb-4">Front Of Shirt Without Sash</h4>
                    <img src={Pathfinder_Insignia_Positions_on_Shirt_no_tie} alt="Shirt Without Sash" className="rounded-lg shadow-md" />
                  </div>
                  <div className="bg-white rounded-2xl shadow-lg p-6">
                    <h4 className="text-xl font-bold text-gray-800 mb-4">Front Of Shirt With Sash</h4>
                    <img src={Pathfinder_Insignia_Positions_on_Shirt_and_the_Sash_no_tie} alt="Shirt With Sash" className="rounded-lg shadow-md" />
                  </div>
                </div>

                {/* Sleeve Images */}
                <div className="mt-12 grid md:grid-cols-2 gap-8">
                  <div className="bg-white rounded-2xl shadow-lg p-6">
                    <h4 className="text-xl font-bold text-gray-800 mb-4">Left Sleeve</h4>
                    <img src={Pathfinder_Uniform_Left_Sleeve} alt="Left Sleeve" className="rounded-lg shadow-md" />
                  </div>
                  <div className="bg-white rounded-2xl shadow-lg p-6">
                    <h4 className="text-xl font-bold text-gray-800 mb-4">Right Sleeve</h4>
                    <img src={Pathfinder_Uniform_Right_Sleeve} alt="Right Sleeve" className="rounded-lg shadow-md" />
                  </div>
                </div>
              </div>
            </section>

            {/* Epaulettes */}
            <section id="Insignia" className="scroll-mt-24 mb-20">
              <div className="bg-gradient-to-br from-white to-purple-50 rounded-3xl shadow-2xl p-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Epaulettes For Coordinators</h2>
                
                <div className="grid md:grid-cols-5 gap-6">
                  {[
                    { img: Area_Pathfinder_Coordinator_Epaulette, title: 'Area' },
                    { img: Conference_Pathfinder_Director_Epaulette, title: 'Conference' },
                    { img: Union_Pathfinder_Director_Epaulette, title: 'Union' },
                    { img: Division_Pathfinder_Director_Epaulette, title: 'Division' },
                    { img: General_Conference_Pathfinder_Director_Epaulette, title: 'General Conference' }
                  ].map((item, idx) => (
                    <div key={idx} className="bg-white rounded-xl p-4 shadow-lg transform hover:scale-110 transition-all duration-300">
                      <div className="text-center font-semibold text-gray-700 mb-3">{item.title}</div>
                      <img src={item.img} alt={item.title} className="rounded-lg" />
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* Song */}
            <section id="Song" className="scroll-mt-24">
              <div className="bg-gradient-to-br from-white to-rose-50 rounded-3xl shadow-2xl p-8">
                <div className="flex items-center justify-center mb-8">
                  <div className="bg-gradient-to-r from-rose-500 to-pink-500 p-4 rounded-xl mr-4">
                    <FontAwesomeIcon icon={faMusic} className="text-white text-3xl" />
                  </div>
                  <h2 className="text-4xl font-bold text-gray-800">Pathfinders Song</h2>
                </div>
                <div className="bg-white rounded-2xl p-8 shadow-lg">
                  <img src={pathfinder_song} alt="Pathfinder Song" className="rounded-xl shadow-md mx-auto" />
                </div>
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}

export default Pathfinders;